import { noSummitCards } from '@lc/const/modifiers';
import { createCardContract } from '@lc/interface/card/contract/factory';

export const ContractMeta = [
	createCardContract(
		117,
		`RELEASE OPEN-SOURCE ORIGAMI BATTERY`,
		`HAVE FOUR (4) OR MORE CARDS IN YOUR HAND`,
		`RECHARGE TWO (2) OF YOUR BATTERIES`,
		`DISCARD A SUMMIT CARD AT RANDOM`,
		`“MAKE 1000 AND GET A WISH.”`
	),
	createCardContract(
		118,
		`THE FLAT EARTH SOCIETY WOULD LIKE YOU TO PROVE THAT THE EARTH IS FLAT`,
		`IMPOSSIBLE. THIS CONTRACT FAILS IMMEDIATELY`,
		`GAIN A FACTORY AND RECHARGE ALL BATTERIES`,
		`YOU ARE NO LONGER ALLOWED TO USE SUMMIT CARDS FOR THE REMAINDER OF THE GAME`,
		`“WE HAVE MEMBERS ALL AROUND THE GLOBE.”`,
		noSummitCards
	),
	createCardContract(
		119,
		`ACTUALLY READ THETERMS AND CONDITIONS`,
		`HAVE THREE (3) COMPLETED CONTRACTS (*NOT INCLUDING THIS ONE*)`,
		`GAIN ONE (1) PRE-CHARGED BATTERY`,
		`REMOVE TWO (2) ENERGY FROM YOUR CUP PER BATTERY THE PLAYER TO YOUR LEFT HAS`,
		`“THIS APP WOULD LIKE PERMISSION TO USE YOUR CAMERA, YOUR LOCATION, AND YOUR SOUL.”`
	),
	createCardContract(
		120,
		`DIRECT BLOCKBUSTER MOVIE "COMEDY OF THE COMMONS”`,
		`YOU AND YOUR NEIGHBORS’ COMBINED PR IS GREATER THAN YOUR COMBINED CARBON FOOTPRINTS`,
		`YOU GET A PRE-CHARGED BATTERY, AND YOUR NEIGHBORS EACH GET AN UNCHARGED BATTERY`,
		`REMOVE FOUR (4) ENERGY FORM YOUR CUP, AND TWO (2) ENERGY FROM EACH OF YOUR NEIGHBORS’ CUPS`,
		`“THIS IS EVEN BETTER THAN THE LI-ION KING!”`
	),
];
